import React from 'react';
import styled from '@emotion/styled';
import { Typography } from 'views/components/atoms/Typography';
import { Color, FontSize } from 'views/constants';

interface StyledBannerProps {
  image: string;
}

const StyledBanner = styled.div<StyledBannerProps>`
  position: relative;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  background-image: url(${({ image }): string => image});
  padding-top: 100px;
`;

const TypographyWrapper = styled.div(`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 288px;
  line-height: 1.5em;
  text-align: center;
  word-break: break-word;
;
`);

interface BannerProps {
  src: string;
  text?: string;
}

export const Banner: React.FC<BannerProps> = ({ src, text }) => {
  return (
    <StyledBanner image={src}>
      {text ? (
        <TypographyWrapper>
          <Typography el="p" color={Color.C6} size={FontSize.S}>
            {text}
          </Typography>
        </TypographyWrapper>
      ) : null}
    </StyledBanner>
  );
};
